import useLoginWithAnotherRole from './useLoginWithAnotherRole'
export default useLoginWithAnotherRole
